var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.444 0.166748H3.55567C1.43234 0.166748 0.166504 1.43258 0.166504 3.55591V8.43841C0.166504 10.5676 1.43234 11.8334 3.55567 11.8334H8.43817C10.5615 11.8334 11.8273 10.5676 11.8273 8.44425V3.55591C11.8332 1.43258 10.5673 0.166748 8.444 0.166748Z",
    fill: "#F9BA33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76954 3.08325H5.95204C5.71287 3.08325 5.51454 3.28159 5.51454 3.52075C5.51454 3.75992 5.71287 3.95825 5.95204 3.95825H7.7137L3.21037 8.46159C3.0412 8.63075 3.0412 8.91075 3.21037 9.07992C3.29787 9.16742 3.4087 9.20825 3.51954 9.20825C3.63037 9.20825 3.7412 9.16742 3.8287 9.07992L8.33204 4.57659V6.33825C8.33204 6.57742 8.53037 6.77575 8.76954 6.77575C9.00871 6.77575 9.20704 6.57742 9.20704 6.33825V3.52075C9.20704 3.28159 9.00871 3.08325 8.76954 3.08325Z",
    fill: "#F9BA33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpYellow);
export default __webpack_public_path__ + "static/media/IconUpYellow.83cbf2ba50ceadd0cf64a98d53b19d39.svg";
export { ForwardRef as ReactComponent };